import { render, staticRenderFns } from "./changeFeeScheme.vue?vue&type=template&id=04aec203&scoped=true"
import script from "./changeFeeScheme.vue?vue&type=script&lang=js"
export * from "./changeFeeScheme.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04aec203",
  null
  
)

export default component.exports